<template>
  <v-app ref="mainapp">
    <component :is="layout" :ref="layout"></component>
    <app-snackbar ref="snackbar"></app-snackbar>
    <confirm-dialog ref="confirm"></confirm-dialog>
    <app-loader-dialog ref="loader"></app-loader-dialog>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import AppLayout from "./layouts/AppLayout";
import SimpleLayout from "./layouts/SimpleLayout";
import StaticDataLayout from "./layouts/StaticData";
import ConfirmDialog from "@/components/globals/ConfirmDialog";
import AppLoaderDialog from "@/components/globals/AppLoaderDialog";
import AppSnackbar from "@/components/globals/AppSnackbar";

const default_layout = "simple-layout";

export default {
  name: "App",
  components: {
    AppLayout,
    SimpleLayout,
    StaticDataLayout,
    ConfirmDialog,
    AppSnackbar,
    AppLoaderDialog,
  },
  computed: {
    layout() {
      return this.$route.meta.layout || default_layout;
    },
    ...mapState("language", ["language", "languages"]),
  },
  mounted() {
    this.setAppLanguage();
    this.$root.$confirm = this.$refs.confirm.open;
    this.$root.$snackbar = this.$refs.snackbar.open;
    this.$root.$loader = this.$refs.loader;
  },
  methods: {
    setAppLanguage() {
      if (
        parseInt(localStorage.language) &&
        parseInt(localStorage.language) !== this.language.locale &&
        this.languages.find(
          (language) => language.id === parseInt(localStorage.language)
        ) !== undefined
      ) {
        this.$store.dispatch(
          "language/changeLanguage",
          parseInt(localStorage.language)
        );
        this.$vuetify.lang.current = this.language.locale;
      } else {
        //fallback to english
        this.$store.dispatch("language/changeLanguage", 2);
        this.$vuetify.lang.current = this.language.locale;
      }
    },
  },
};
</script>
